export const PENDING_STATUS = 'Pending'
export const DECLINED_STATUS = 'Declined'
export const APPROVED_STATUS = 'Approved'
